import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import MyI18NextBackend from './myI18NextBackend';
import CustomFormatter from './formatter';
import translationsEn from './translationsEn';
import BootstrapVue from 'bootstrap-vue';
import DOMPurify from 'dompurify';
import VueNativeSock from 'vue-native-websocket';
import { RPC } from '@/plugins/rpc';
import ClickOutside from '@/plugins/clickOutside';
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VueLuxon from 'vue-luxon';
import Vuelidate from 'vuelidate';
import InternalTracker from './InternalTracker';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import LogRocket from 'logrocket';
import UniqueId from 'vue-unique-id';
import Snotify from 'vue-snotify';
import wysiwyg from 'vue-wysiwyg';
import VueMq from '@/vue-mq/src';
import Vue2TouchEvents from 'vue2-touch-events';
import vueHeadful from 'vue-headful';

import '@/fontAwesome.js';

// window.ICAL = {};

console.dir(InternalTracker);
InternalTracker.init();

Sentry.init({
  dsn: 'https://f688075ed18b494eb1e4f98cbc84da41@sentry.io/1853632',
  integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true }),
    new Sentry.Integrations.Breadcrumbs({ console: false })],
  beforeSend(event, hint) {
    if (!store.state.sentryEnabled) {
      return null;
    }
    // Check if it is an exception, and if so, show the report dialog
    if (event.exception) {
      Sentry.showReportDialog({ eventId: event.event_id });
    }
    return event;
  }
});

LogRocket.getSessionURL(sessionURL => {
  Sentry.configureScope(scope => {
    scope.setExtra('sessionURL', sessionURL);
  });
});

Vue.component('vue-headful', vueHeadful);

Vue.use(Vue2TouchEvents);
Vue.use(BootstrapVue);
Vue.use(VueI18Next);
Vue.use(VuejsDialog, { backdropClose: true, animation: 'zoom' });
Vue.use(Vuelidate);
Vue.use(wysiwyg, {});
Vue.use(VueMq, { breakpoints: { sm: 400, md: 768, lg: 1100, hg: Infinity } });

Vue.use(VueLuxon, {
  serverZone: 'local'
});
Vue.use(UniqueId);
Vue.use(Snotify, {
  maxAtPosition: 2,
  toast: {
    timeout: 10000
  }
});

Vue.use(VueNativeSock, 'ws://localhost:5108', {
  connectManually: true,
  store: store,
  format: 'json'
});

Vue.directive('click-outside', ClickOutside);

Vue.prototype.$RPC = RPC;

const getInitialLanguage = () => {
  const x = store.state.language;
  return x;
};

i18next
  .use(MyI18NextBackend)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    debug: true,
    ns: ['translation', 'general'],
    defaultNS: 'translation',
    interpolation: {
      format: CustomFormatter
    },
    backend: {
      type: 'user'
    }
  });

i18next.addResourceBundle('en', 'general', translationsEn.general);
i18next.addResourceBundle('en', 'translation', translationsEn.translation);

if (process.env.NODE_ENV !== 'development') {
  i18next.reloadResources('en');
}

// When showing HTML emails, change links to 'target: "_blank"'
DOMPurify.addHook('afterSanitizeAttributes', function(node) {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank');
  }
  // set non-HTML/MathML links to xlink:show=new
  if (!node.hasAttribute('target') && (node.hasAttribute('xlink:href') || node.hasAttribute('href'))) {
    node.setAttribute('xlink:show', 'new');
  }
});

const i18n = new VueI18Next(i18next);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
